<template>
  <div>
    <EvgGoodInfo :disabled="disabled" :evgSkuCode="evgSkuCode" />
  </div>
</template>
<script>
import EvgGoodInfo from '../components/evg-good-info'
export default {
  name: 'ecom-base-evgGoods-detail',
  components: { EvgGoodInfo },
  data() {
    return { activeName: 'skuBase', evgSkuStatus: '' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
    evgSkuCode() {
      return this.params.evgSkuCode
    },
  },
}
</script>
